import React from "react";
import Masked from "common/Masked";
import styled from "styled-components";

const doesNothing = () => {};

const EditClientButton = ({ onClick = doesNothing }) => (
  <a className="waves-effect borderless" onClick={onClick}>
    <i className="material-icons">edit</i>
  </a>
);
const DeleteClientButton = ({ onClick = doesNothing }) => (
  <a className="waves-effect borderless" onClick={onClick}>
    <i className="material-icons">delete</i>
  </a>
);
const SecretTD = styled.td`
  max-width: 20ch;
  white-space: pre-wrap;
`;

const ClientItem = ({
  id,
  address = "",
  description = "",
  secret = "",
  deleted,
  even = false,
  onDelete = doesNothing,
  onEdit = doesNothing,
}) => {
  if (deleted === true) {
    return null;
  }
  const doClientDelete = () => {
    onDelete(id);
  };

  const doClientEdit = () => {
    onEdit(id);
  };

  return (
    <React.Fragment>
      <tr className={`${even ? "even" : "odd"}`}>
        <td>{address}</td>
        <td>{description}</td>
        <SecretTD>
          <Masked>{secret}</Masked>
        </SecretTD>
        <td className="text-center hides-content-to-operators">
          <DeleteClientButton onClick={doClientDelete} />
          <EditClientButton onClick={doClientEdit} />
        </td>
      </tr>
    </React.Fragment>
  );
};
const ClientsList = ({
  items = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
}) => (
  <table className="table table-striped">
    <thead>
      <tr>
        <th>ADDRESS</th>
        <th>DESCRIPTION</th>
        <th>SECRET</th>
        <th className="text-center">ACTIONS</th>
      </tr>
    </thead>
    <tbody>
      {items
        .filter(({ deleted }) => deleted !== true)
        .map(({ __id, ...client }, index) => (
          <ClientItem
            id={__id}
            key={__id}
            {...client}
            even={(index + 1) % 2 === 0}
            onDelete={() => onDelete(__id)}
            onEdit={() => onEdit(__id)}
          />
        ))}
    </tbody>
  </table>
);
export default ClientsList;
